import { render, staticRenderFns } from "./companySeparationSetup.vue?vue&type=template&id=388f541b"
import script from "./companySeparationSetup.vue?vue&type=script&lang=js"
export * from "./companySeparationSetup.vue?vue&type=script&lang=js"
import style0 from "./companySeparationSetup.vue?vue&type=style&index=0&id=388f541b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports